module.exports = __webpack_public_path__ + "media/fonts/ABC_Weise_Regular_201015-06c05e5f50a8b5ef2bb1ca44926d9d09.woff";